import css from "styled-jsx/css";
import { MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";

export const componentStyles = css`
  .tab-component {
    position: relative;
    text-align: center;
    min-width: 240px;
    cursor: pointer;
    padding-bottom: 16px;

    :hover {
      outline: 0;
    }

    &.active {
      .tab-underline-placeholder {
        .tab-underline {
          left: 0;
          right: 0;
        }
      }
    }

    &.small-labels {
      min-width: 160px;

      .tab-label {
        font-size: 16px;
      }
    }

    .tab-label {
      font-weight: 700;
      font-size: 24px;
    }

    .tab-underline-placeholder {
      position: absolute;
      height: 5px;
      bottom: 0;
      left: 0;
      right: 0;

      .tab-underline {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        right: 50%;
        transition: left 0.2s ease, right 0.2s ease;
      }
    }
  }
`;
